import { Component } from 'preact'
import Header from '../../header'
import AlertComponent from '../../ui-components/AlertComponent'
import InputGroup from '../../ui-components/InputGroup'
import Permissions from './Permissions'
import CategoryType from './CategoryType'
import CategoryTabs from './CategoryTabs'
import IncludeForStats from './IncludeForStats'
import Attachments from './Attachments'
import CategoryContentCurationManager from '../../content-curation/CategoryContentCurationManager'
import tracker from '../../../components/tracker/publish'
import axios from 'axios'

const eventTracker = (category) => {
  tracker.trackEvent('userevent', {
    type: 'Category Page Saved',
    category_title: category.title,
    category_type: category.type === 2 ? 'ideation' : 'default',
    category_has_hero_image: category.heroImage !== null,
    content_curation_visible: category.contentCuration.enabled,
    category_list_visible: category.contentCuration.enabledCommunityList,
    content_curation_number_of_links: category.contentCuration.curatedTopics.length
  })
}

class CategoryEdit extends Component {
  constructor (props) {
    super()
    this.state = {
      messageType: null,
      errors: [],
      category: props.category,
      showModal: false,
      showConfirmation: false,
      showError: false,
      successMessage: '',
      activeTab: 0
    }
    this.saveCategory = this.saveCategory.bind(this)
    this.setValue = this.setValue.bind(this)
    this.disableCreatePermissionsList = ['roles.not-activated', 'roles.requires-approval', 'roles.guest', 'roles.banned']
    this.categoryTabs = ['Category Details', 'Curated Content', 'Permissions']
  }

  saveCategory () {
    const newData = JSON.parse(JSON.stringify(this.state.category))
    let errors = []

    if (!newData.title || newData.title === '') {
      errors.push('title')
    }
    if (!newData.description || newData.description === '') {
      errors.push('description')
    }
    if (errors.length) {
      this.setState({ errors })
      return
    }

    newData.contentCuration.curatedTopics = this.state.category.contentCuration.curatedTopics.map(t => t.id)
    axios.post('/settings/category/new', newData, { params: { parentId: this.state.category.parentId } })
      .then(() => {
        eventTracker(newData)
        this.setState({ messageType: 'success' })
        window.location.assign(this.props.overviewLink)
      })
      .catch(() => {
        this.setState({ messageType: 'error' })
      })
  }

  setValue (key, value) {
    const category = Object.assign({}, this.state.category, { [key]: value })
    this.setState({ category, errors: [] })
  }

  componentDidMount () {
    const mainList = [].concat(this.props.roles.main)
    const updatedMainList = mainList.reverse().reduce((accumulator, currentValue) => {
      if (this.disableCreatePermissionsList.indexOf(currentValue.role) !== -1) {
        currentValue.create_topics = false
        currentValue.create_posts = false
      }
      return [currentValue].concat(accumulator)
    }, [])

    const concatList = [].concat(updatedMainList).concat(this.props.roles.custom)
    this.setValue('permissions', concatList)
  }

  render (props, state) {
    return (
      <div className='category-edit_container'>
        <Header
          title='Edit category'
          disableCancelButton
          disableSaveButton
        />
        <AlertComponent messageType={state.messageType} />
        <CategoryTabs
          tabs={this.categoryTabs}
          activeTab={state.activeTab}
          onCallback={(activeTab) => this.setState({ activeTab })}
        />
        {
          this.categoryTabs[state.activeTab] === 'Category Details' ? (
            <form>
              <InputGroup
                title='Title'
                placeholder='Add a title'
                type={'text'}
                error={state.errors.indexOf('title') !== -1 ? 'Please fill in this field' : ''}
                onChange={(e) => this.setValue('title', e.target.value)}
                value={state.category.title} />
              <InputGroup
                title='Description'
                placeholder='Add a description'
                error={state.errors.indexOf('description') !== -1 ? 'Please fill in this field' : ''}
                type={'text'}
                onChange={(e) => this.setValue('description', e.target.value)}
                value={state.category.description} />
              <IncludeForStats
                enable={state.category.includeForStats}
                onUpdate={(value) => this.setValue('includeForStats', value)}
              />
              <CategoryType
                currentType={state.category.type}
                onUpdate={(value) => this.setValue('type', value)}
              />
              <Attachments
                label='Hero image'
                className='hero-image'
                meta={
                  <div>
                    <div>Hero image will be shown on top of the category page.</div>
                    <div>Maximum file size: 5MB. Allowed image types: .jpg, .png, .gif. We recommend a minimum of 2880*480px</div>
                  </div>
                }
                isAttachmentSelected={state.category.heroImage}
                imageSrc={state.category.heroImage && state.category.heroImage.source_thumb}
                width={2880}
                height={480}
                onUpdate={(data) => this.setValue('heroImage', data)}
              />
              <Attachments
                label='Thumbnail image'
                className='thumbnail-image'
                meta={
                  <div>
                    <div>Allowed image types: .jpg, .png, .gif. We recommend a minimum of 144*144px</div>
                  </div>
                }
                isAttachmentSelected={state.category.thumbnailImage}
                imageSrc={state.category.thumbnailImage && state.category.thumbnailImage.source_thumb}
                width={144}
                height={144}
                onUpdate={(data) => this.setValue('thumbnailImage', data)}
              />
            </form>
          ) : null
        }
        {
          this.categoryTabs[state.activeTab] === 'Curated Content' ? (
            <CategoryContentCurationManager
              description='Display a list of curated content, such as articles, tutorials and guides to help users find their answers quickly.'
              contentCuration={state.category.contentCuration}
              onChange={(value) => this.setValue('contentCuration', { ...state.category.contentCuration, ...value })}
            />
          ) : null
        }
        {
          this.categoryTabs[state.activeTab] === 'Permissions' ? (
            <Permissions
              isKnowledgeBase={false}
              mainCount={this.props.roles.main.length}
              disableCreatePermissionsList={this.disableCreatePermissionsList}
              permissions={state.category.permissions || []}
              onUpdate={(data) => this.setValue('permissions', data)}
            />
          ) : null
        }
      </div>
    )
  }
}

export default CategoryEdit
